import actionTypes from "_constants/actionTypes";

export const profileActions = {
  saveName,
  endTransaction,
  saveItem,
  getItems,
  getAvItems,
};
function endTransaction() {
  return {
    type: actionTypes.END_TRANSACTION,
  };
}

function getAvItems(payload) {
  return {
    type: actionTypes.GET_AVITEMS,
    payload: payload,
  };
}

function saveItem(payload) {
  return {
    type: actionTypes.SAVE_ITEM,
    payload: payload,
  };
}

function getItems(payload) {
  return {
    type: actionTypes.GET_ITEMS,
    payload: payload,
  };
}

function saveName(payload) {
  return {
    type: actionTypes.SAVE_NAME,
    payload: payload,
  };
}
